<template>

    <li
        class="c-form_tag"
        :class="{
      'c-form_tag--fade_in' : fadeIn,
      'c-form_tag--fade_out' : fadeOut }">
        <span class="c-form_tag__name">{{ title }}</span>
        <button type="button" tabindex="-1" class="c-form_tag__delete tagDelete" @click="remove"></button>
    </li>

</template>

<script>

export default {

    name: 'FormTag',

    props: {
        title: String,
        animate: Boolean
    },

    data() {
        return {
            fadeOut: false,
            fadeIn: !this.animate
        }
    },

    methods: {
        remove() {
            this.$el.style.width = this.$el.clientWidth + 'px'
            this.fadeOut = true
            setTimeout(() => {
                this.$emit('delete', this.title)
            }, 400)
        }
    },

    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.fadeIn = true
            }, 50)
        })
    }

}

</script>

<style lang="scss">

@import '~Style/_utils.scss';

.c-form_tag {
    position: relative;
    margin: 2.5px 5px;
    display: inline-block;
    background-color: #FAFAFC;
    border-radius: 0.25rem;
    overflow: hidden;

    transform: translate3d(-20px, 0, 0);
    opacity: 0;

    transition-properties: opacity, transform, width, margin;
    transition-duration: .3s;
    transition-timing-function: cubic-bezier(.32, .14, .25, 1);

    &--fade_in {
        transform: translate3d(0, 0, 0);
        opacity: 1;
    }
    &--fade_out {
        width: 0 !important;
        opacity: 0;
        margin-left: 0;
        margin-right: 0;
    }
    &__name {
        display: block;
        font-weight: bold;
        color: #9FA9BA;
        font-size: .9rem;
        line-height: 1rem;
        padding: 0.7rem 3rem 0.7rem 1.2rem;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
    }
    &__delete {
        display: block;
        border: 0;
        background-color: transparent;
        position: absolute;
        top: 50%;
        right: 1.2rem;
        transform: translateY(-50%);
        width: 1em;
        height: 1em;
        background-image: url('#{$icons}/delete1.svg');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
    }
}

</style>
